export async function createForeignBankAccount(bankAccountRepository, bankAccount) {
  return bankAccountRepository.save(bankAccount);
};

